/**
 * @desc 获取登录状态
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(params: API.auth.authorizationCode.getLoginState.Params, options?: any) {
  return updateResponse(
    http(URL + `/authCode/loginState`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
